module.exports = __webpack_public_path__ + "static/media/mh-1.a60e6747.jpg";